
export class NotificacionDto {
	titulo: string;
	cuerpo: string;
	idGrupo: number;
	tipoNotificacion: string;
	isGroup: boolean;
	idSocio: number;
	tipoEnvio: string;
	fechaEnvio: string;
	horaEnvio: number;
	despues: string;
}
